import React from "react";
import { Lightbulb, Info, Sparkles } from "lucide-react";
import Diagram from "./Diagram";

const Callout = ({ style, title, text }) => {
 const icon =
 style === "tip" ? <Lightbulb className="w-5 h-5" /> :
 style === "info" ? <Info className="w-5 h-5" /> :
 <Sparkles className="w-5 h-5" />;
 const palette =
 style === "tip" ? "bg-amber-50 border-amber-300 text-amber-900 "
 : "bg-orange-50 border-orange-300 text-orange-900 ";
 return (
 <aside className={`my-6 border-l-4 rounded-sm p-5 ${palette}`}>
 <div className="flex items-start gap-3">
 <div className="shrink-0 mt-0.5">{icon}</div>
 <div>
 {title && <div className="font-heading font-bold text-base mb-1">{title}</div>}
 <div className="text-base leading-relaxed">{text}</div>
 </div>
 </div>
 </aside>
 );
};

const Analogy = ({ title, text }) => (
 <aside className="my-6 border border-dashed border-zinc-300 rounded-sm p-5 bg-zinc-50 ">
 <div className="text-xs uppercase tracking-[0.2em] text-orange-600 font-semibold mb-1">
 Analogy
 </div>
 {title && <div className="font-heading font-bold text-lg mb-1 text-zinc-900 ">{title}</div>}
 <div className="text-base leading-relaxed text-zinc-700 italic">“{text}”</div>
 </aside>
);

const TopicContent = ({ topic }) => (
 <article className="prose max-w-none">
 {topic.diagram_key && (
 <Diagram diagramKey={topic.diagram_key} caption={topic.title} />
 )}
 {topic.blocks?.map((b, i) => {
 if (b.type === "heading") {
 return (
 <h3
 key={i}
 className="font-heading text-xl md:text-2xl font-semibold mt-8 mb-3 text-zinc-900 scroll-mt-24"
 >
 {b.text}
 </h3>
 );
 }
 if (b.type === "paragraph") {
 return (
 <p
 key={i}
 className="text-base md:text-lg leading-relaxed text-zinc-700 mb-4"
 >
 {b.text}
 </p>
 );
 }
 if (b.type === "list") {
 return (
 <ul key={i} className="my-4 space-y-2 list-none pl-0">
 {b.items.map((it, j) => (
 <li key={j} className="flex items-start gap-3 text-base md:text-lg text-zinc-700 ">
 <span className="mt-2.5 w-2 h-2 rounded-full bg-orange-500 shrink-0" />
 <span>{it}</span>
 </li>
 ))}
 </ul>
 );
 }
 if (b.type === "callout") {
 return <Callout key={i} style={b.style} title={b.title} text={b.text} />;
 }
 if (b.type === "analogy") {
 return <Analogy key={i} title={b.title} text={b.text} />;
 }
 return null;
 })}
 </article>
);

export default TopicContent;
